/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from "vuex";
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from "../../../../share/util/individualDiagnose";
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  WAIT: 'wait',
  EXECUTE_SUCCESS: 'execute_success',
  EXECUTE_ERROR: 'execute_error',
  FAILED: 'failed'
};

export default {
  name: 'requirement090',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      systemId: '',
      displayInfo: '',
      modal_requirement_090: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    // 無し
  },

  computed: {

    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.EXECUTE_ERROR:
        case PHASE.FAILED:
          return 'danger';
        case PHASE.EXECUTE_SUCCESS:
          return 'success';
        case PHASE.START:
        case PHASE.WAIT:
        default:
          return 'secondary';
      }
    },

    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId
    }),
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      // ECUキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_requirement_090 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_090 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.isLoading = false;
      // 異常終了：エラー表示
      this.phase = PHASE.FAILED;
      return;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result handler.validate で返ってきたバリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック (Vuex の Action を呼び出している点に注意)
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック (Vuex の Action を呼び出している点に注意)
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 実行処理 */
    async executeProcess() {
      try {
        this.isLoading = true;
        // 実行監視へ遷移
        this.phase = PHASE.WAIT;
        // バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              switch (response.data.user_data.routine_status) {
                case '0002':
                  // 正常
                  this.phase = PHASE.EXECUTE_SUCCESS;
                  break;
                default:
                  // 異常
                  this.phase = PHASE.EXECUTE_ERROR;
                  break;
              }
              this.displayInfo = this.i18nWsKey + '.REQ_WS_90_TXT_3_' + response.data.user_data.routine_status;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },

  async mounted() {
    this.init();
  },
};

